import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import affiliationCodeConversion from '@/store/affiliation-code-conversion';
import bulkAddUsers from '@/store/bulk-add-users';
import notificationData from '@/store/notification-data';
import organization from '@/store/organization';
import processingStatusOrganizations from '@/store/processing-status-organizations';
import processingStatusUsers from '@/store/processing-status-users';
import processingRequests from '@/store/processing-requests';
import user from '@/store/user';
import samlAuthentication from '@/store/saml-authentication';
import parameterSettings from '@/store/parameter-settings';
import personnelChange from '@/store/personnel-change';
Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })],
    modules: {
        affiliationCodeConversion,
        bulkAddUsers,
        notificationData,
        organization,
        processingStatusOrganizations,
        processingStatusUsers,
        processingRequests,
        user,
        samlAuthentication,
        parameterSettings,
        personnelChange
    },
    state: {
        /** タイトルアイコン(表示アイコン) */
        titleIcon: '',

        /** メインタイトル(表示タイトル) */
        mainTitle: '',

        /** 通信処理中フラグ */
        isConnecting: false,

        /** エラーメッセージ(共通エラーメッセージ表示画面用) */
        errorMessage: '',

        /** 遷移元画面パス */
        beforeDisplayPath: '',

        /** 認証状態（true:認証済、false:未認証） */
        isSamlAuthenticationStatus: false,

        /** 認証ユーザー情報 */
        authenticationUser: null,

        /** アクセスログ出力フラグ */
        isAccessLog: false,

        /** アクセスログに出力する画面名 */
        displayName: '',

        /** アクセスログ用詳細更新削除画面等ID */
        logDisplayId: null
    },

    /**
     * stateの値を編集して返す関数を定義する
     */
    getters: {
        // 遷移元画面パス
        getBeforeDisplayPath: state => {
            return state.beforeDisplayPath
        }
    },

    /**
     * ミューテーション経由でstateの値を変更しないと
     * sessionに変更内容が格納されないことがあるので注意
     * stateの参照はthis.$store.state.isConnectingのように直接参照することも可
     */
    mutations: {
        /** セッター： state.isConnecting */
        setIsConnecting(state: any, isConnecting: boolean) {
            state.isConnecting = isConnecting;
        },

        /** セッター： state.titleIcon */
        setTitleIcon(state, titleIcon: string) {
            state.titleIcon = titleIcon;
        },

        /** セッター： state.mainTitle */
        setMainTitle(state, mainTitle: string) {
            state.mainTitle = mainTitle;
        },

        /** セッター： state.errorMessage */
        setErrorMessage(state, message: string) {
            state.errorMessage = message;
        },

        /** セッター： state.beforeDisplayPath */
        setBeforeDisplayPath(state: any, from: string) {
            state.beforeDisplayPath = from;
        },

        /** 遷移元画面パス初期化 */
        resetBeforeDisplayPath(state: any) {
            state.beforeDisplayPath = '';
        },

        /** エラーメッセージ初期化 */
        resetErrorMessage(state) {
            state.errorMessage = '';
        },

        /** セッター： state.isSamlAuthenticationStatus */
        setAuthenticationStatus(state, isSamlAuthenticationStatus: boolean) {
            state.isSamlAuthenticationStatus = isSamlAuthenticationStatus;
        },

        /** セッター： state.authenticationUser */
        setAuthenticationUser(state, authenticationUser: any) {
            state.authenticationUser = authenticationUser;
        },

        /** セッター： state.isAccessLog */
        setIsAccessLog(state: any, isAccessLog: boolean) {
            state.isAccessLog = isAccessLog;
        },
  
        /** セッター： state.displayName */
        setDisplayName(state: any, displayName: string) {
            state.displayName = displayName;
        },

        /** セッター：state.logDisplayId */
        setLogDisplayId(state, logDisplayId) {
            state.logDisplayId = logDisplayId;
        }
    },

    /**
     * 通信関連の処理を定義する
     */
    actions: {
    },
});
